import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Tooltip from 'root/module/tooltip';
import Constants from 'root/constants';
import Modals from 'root/modals';
import View from 'view/base';
import View_Emoji from 'view/emoji';
import View_Comment_Template from 'view/comment_template';
import Dnd_File_Uploader from 'root/module/dnd_file_uploader';

export default View.extend({
    className: 'thread-reply-form',

    is_public: true,

    attachment_info: {},
    video_capture_info: {},

    mention_list : [], // people that can be notified
    notify_list  : [],  // people that will be notified

    placeholder: 'Add a comment...',

    selection_focus_node  : null,
    selection_focus_offset: null,

    events: {
        'click .comment-status-launcher input:checkbox' : 'togglePublic',
        'click .mention-launcher'                       : 'openMeontionList',
        'click .emoji-launcher'                         : 'openEmoji',
        'click .attachment-launcher'                    : 'attachFile',
        'click .attachment-remove'                      : 'removeAttachment',
        'click .new-comment-attachment-video'           : 'previewVideoAttachment',
        'focus .new-comment'                            : 'onFocus',
        'keydown .new-comment'                          : 'replyKeydown',
        'paste .new-comment'                            : 'replyPaste',
        'keyup .new-comment'                            : 'replyKeyup',
        'click .new-comment'                            : 'replyClick',
        'click .mention-list li'                        : 'selectMentionList',
        'click .at-list li'                             : 'selectAtList',
        'click .reply-submit'                           : 'replySubmit',
        'click .template-launcher'                      : 'onClickCommentTemplateDropdown',
    },

    dom_handlers: {
        onFocus: function(e) {
            this.$el.find('.new-comment').siblings('.new-comment-action-bar').show();
        },

        onClickCommentTemplateDropdown: function(e) {
            if (Cache.account.hasFeature('reply_templates')) {
                this.views.comment_template.reset();
            } else {
                Modals.unlockFeature('Reply templates is not available in your plan.<br>Upgrade your plan to get access.');
            }
        },

        togglePublic: function(e) {
            var internal = $(e.currentTarget).prop('checked');

            this.is_public = !internal;

            if (!this.is_public) {
                // remove reporter and clients from notify list
                var notify_list_new = [];

                this.notify_list.forEach((email) => {
                    var user = Cache.user.findWhere({email: email});

                    if (user) {
                        var user_role = this.getUserRole(user.id);

                        if (user_role !== Constants.CLIENT) {
                            notify_list_new.push(email);
                        }
                    }
                });

                this.notify_list = notify_list_new;
            }

            this.updateMentionDropdown(); // this disables public users in the mention list

            this.$el.toggleClass('internal', !this.is_public);
        },

        openMeontionList: function(e) {
            if ($(e.currentTarget).offset().top > 400) {
                this.$el.find('.mention-list').attr('direction', 'up').addClass('dropdown-box-up');
            } else {
                this.$el.find('.mention-list').removeAttr('direction').removeClass('dropdown-box-up');
            }

            this.$el.find('.mention-list').toggle();
        },

        openEmoji: function(e) {
            if (!(this.views.emoji instanceof View_Emoji)) {
                this.views.emoji = new View_Emoji({
                    onSelect: this.onEmojiSelect.bind(this),
                    launcher: this.$el.find('.emoji-launcher')
                });

                this.views.emoji.load();
                this.views.emoji.render().$el.hide().appendTo(this.$el.find('.region-emoji'));
            }

            if ($(e.currentTarget).offset().top > 400) {
                this.$el.find('.emoji-selector').attr('direction', 'up');
            } else {
                this.$el.find('.emoji-selector').removeAttr('direction');
            }

            this.views.emoji.toggle();
        },

        attachFile: function(e) {
            if (this.attachment_info.file_name) {
                return;
            }

            Util.uploadFile(10, function(error, file_name, file_type, file_content) {
                if (error) {
                    UI.error(error);
                    return;
                }

                this.renderAttachment(file_name, file_type, file_content);
            }.bind(this));
        },

        removeAttachment: function(e) {
            this.$el.find('.new-comment-attachment').html('');
            this.attachment_info = {};
            this.video_capture_info = {};

            this.$el.find('.attachment-launcher').removeClass('disabled');
        },

        previewVideoAttachment: function(e) {
            if ($(e.target).hasClass('attachment-remove')) {
                return;
            }

            Modals.previewVideo(this.attachment_info.file_content);
        },

        replyKeydown: function(e) {
            // move selection in dropdown
            if (this.mention_list.length && this.$el.find('.at-list').is(':visible')) {
                if (e.which === 38 || e.which === 37) {
                    // Left or Up
                    e.preventDefault();

                    var new_item;
                    var current_item = this.$el.find('.at-list li.active:visible:last');
                    if (current_item.length) {
                        new_item = current_item.prevAll(':visible:first');
                    } else {
                        new_item = this.$el.find('.at-list li:visible:last');
                    }

                    if (new_item.length) {
                        this.$el.find('.at-list li').removeClass('active');
                        new_item.addClass('active');
                    }

                    return;
                } else if (e.which === 39 || e.which === 40) {
                    // Right or Down
                    e.preventDefault();

                    var new_item;
                    var current_item = this.$el.find('.at-list li.active:visible:last');
                    if (current_item.length) {
                        new_item = current_item.nextAll(':visible:first');
                    } else {
                        new_item = this.$el.find('.at-list li:visible:first');
                    }

                    if (new_item.length) {
                        this.$el.find('.at-list li').removeClass('active');
                        new_item.addClass('active');
                    }

                    return;
                } else if (e.which === 9 || e.which === 13 || e.which === 32) {
                    // Tab, Enter and Space
                    // if there is only one visible, select it
                    if (this.$el.find('.at-list li:visible').length === 1) {
                        this.$el.find('.at-list li:visible').addClass('active');
                    }

                    if (this.$el.find('.at-list li.active').filter(':visible').length) {
                        // Enter or Space
                        e.preventDefault();
                        this.$el.find('.at-list li.active').filter(':visible').click();
                    }

                    return;
                }
            }
        },

        replyPaste: function(e) {
            e.preventDefault();

            try {
                var text = (e.originalEvent || e).clipboardData.getData('text/plain');
                document.execCommand('insertText', false, text);

                var text = this.$el.find('.new-comment').text();

                if (text.match(/@all/i)) {
                    this.addAllToNotifyList();
                } else {
                    this.mention_list.forEach((list) => {
                        if (list.name) {
                            var regex = new RegExp('@' + list.name, 'g');
                            if (text.match(regex)) {
                                if (this.notify_list.indexOf(list.email) === -1) {
                                    this.notify_list.push(list.email);
                                }
                            }
                        }
                    });
                }

                this.updateMentionDropdown();
            } catch(e) {
            }
        },

        replyKeyup: function(e) {
            try {
                this.comment_selection = window.getSelection().getRangeAt(0);
            } catch(e) {
                this.comment_selection = null;
            }

            // no @ when not logged in
            if (!Cache.real_user_id) {
                return;
            }

            // Cache dom elements
            var new_comment = this.$el.find('.new-comment');
            var at_list     = this.$el.find('.at-list');
            var at_list_li  = at_list.find('li');

            // clean up the extra <br> tag
            if (new_comment.html() === '<br>') {
                new_comment.html('');
                return;
            }

            if (!at_list_li.length) {
                return;
            }

            var text = '';
            var selection = document.getSelection();

            if (selection && selection.focusNode) {
                this.selection_focus_node   = selection.focusNode;
                this.selection_focus_offset = selection.focusOffset;

                var value  = selection.focusNode.nodeValue;
                var offset = selection.focusOffset;

                if (value && offset) {
                    text = value.substr(0, offset);
                }
            } else {
                this.selection_focus_node   = null;
                this.selection_focus_offset = null;
            }

            if (!text) {
                at_list.hide();
                return;
            }

            var at_position = text.lastIndexOf('@');

            if (at_position === -1) {
                at_list.hide();
                return;
            }

            var at_name = text.substr(at_position);

            at_list_li.show();
            at_list.show();

            // zero-width charater
            if (at_name === '@' || (at_name.length === 2 && at_name.charAt(0) === '@' && at_name.charCodeAt(1) === 8204)) {
                // show all the dropdown options
                // select the first option by default
                if (!at_list.find('li.active').length) {
                    at_list.find('li:first').addClass('active');
                }
            } else {
                // name matching in the dropdown
                at_name = at_name.replace(/@/, '');

                var found_count = 0;
                at_list_li.each(function() {
                    var dropdown_value = $(this).text();

                    if ($(this).data('id') == -1) {
                        dropdown_value = 'all';
                    }

                    // TODO ????
                    if (false && dropdown_value.toLowerCase() === at_name.toLowerCase() && e.which !== 8 && e.which !== 37 && e.which !== 38 && e.which !== 39 && e.which !== 40) {
                        $(this).hide();
                        $(this).click();
                    } else if (dropdown_value.toLowerCase().indexOf(at_name.toLowerCase()) === -1) {
                        $(this).hide();
                    } else {
                        $(this).show();
                        found_count++;
                    }
                });

                if (found_count === 0) {
                    at_list.hide();
                }
            }
        },

        replyClick: function(e) {
            try {
                this.comment_selection = window.getSelection().getRangeAt(0);
            } catch(e) {
                this.comment_selection = null;
            }
        },

        selectMentionList: function(e) {
            e.stopPropagation();

            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var user_id = $(e.currentTarget).data('id');

            if (user_id === undefined) {
                return;
            }

            if (user_id == -1) {
                // select all
                this.addAllToNotifyList();
                this.$el.find('.mention-list').hide();
            } else {
                var email = user_id ? Cache.user.get(user_id).get('email') : this.feedback.get('email');
                var email_index = this.notify_list.indexOf(email);

                if (email_index === -1) {
                    this.notify_list.push(email);
                } else {
                    this.notify_list.splice(email_index, 1);
                }
            }

            this.updateMentionDropdown();
        },

        selectAtList: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var user_id = $(e.currentTarget).data('id');
            var user_name;
            var user_email;

            if (user_id == -1) {
                user_name = 'all';
                this.addAllToNotifyList();
            } else {
                user_name  = Cache.user.get(user_id).get('name');
                user_email = Cache.user.get(user_id).get('email');

                if (this.notify_list.indexOf(user_email) === -1) {
                    this.notify_list.push(user_email);
                }
            }

            if (this.selection_focus_node) {
                var node = this.selection_focus_node;
                var element_node = document.createElement('span');

                element_node.className = 'at-name';
                element_node.setAttribute('contenteditable', 'false');
                element_node.setAttribute('userid', user_id);
                element_node.innerHTML = '@' + user_name;

                var wrapper = document.createElement('span');
                wrapper.appendChild(document.createTextNode('\u200C'));
                wrapper.appendChild(element_node);
                wrapper.appendChild(document.createTextNode('\u200C'));

                var head   = node.textContent.substr(0, this.selection_focus_offset);
                var length = head.length - head.lastIndexOf('@');

                this.comment_selection.setStart(node, this.selection_focus_offset - length);
                this.comment_selection.setEnd(node, this.selection_focus_offset);
                this.comment_selection.deleteContents();

                this.comment_selection.insertNode(wrapper);

                this.comment_selection.collapse(false);

                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.comment_selection);
            }

            this.$el.find('.at-list li').removeClass('active');

            this.updateMentionDropdown();

            this.selection_focus_node = null;
            this.selection_focus_offset = null;
        },

        replySubmit: function(e) {
            var comment = this.getComment();

            if (!comment && !this.attachment_info.file_content) {
                return;
            }

            Tooltip.removeAll();

            this.trigger('submit', {
                comment       : comment,
                attachment    : this.attachment_info,
                video_capture : this.video_capture_info,
                is_public     : this.is_public,
                notify_list   : this.notify_list
            });
        },

        documentClick: function(e) {
            // if the e.targe is under comment-template-box
            if ($(e.target).closest('.comment-template-box').length) {
                return;
            }

            if (this.$el.is(':hidden')) {
                return;
            }

            this.$el.find('.at-list').hide();

            if (!$(e.target).hasClass('.mention-launcher') && !$(e.target).parents('.mention-launcher').length) {
                this.$el.find('.mention-list').hide();
            }

            // hide editor
            if (!this.hasUnsavedChanges()) {
                if (!this.$el.find($(e.target)).length) {
                    this.$el.find('.new-comment').siblings('.new-comment-action-bar').hide();
                }
            }
        }
    },

    event_handlers: {
        handleFiles: function(files) {
            this.$el.find('.dnd-dropzone').hide();

            if (files.length === 0) {
                return;
            }

            if (this.attachment_info.file_name) {
                return;
            }

            var result = Util.readFile(files[0], 10, (file_name, file_type, file_content) => {
                this.renderAttachment(file_name, file_type, file_content);
            });

            if (result !== true) {
                UI.error(result);
            }
        },

        handleDragEnter: function() {
            this.$el.find('.new-comment').siblings('.new-comment-action-bar').show();
            this.$el.find('.dnd-dropzone').show();
            this.$el.find('.new-comment').focus();
        },

        handleDragLeave: function(event) {
            if (event.target === this.$el.find('.dnd-dropzone').get(0)) {
                this.$el.find('.dnd-dropzone').hide();
            }
        },

        handleCommentInsert: function(content) {
            this.$el.find('.new-comment').focus();

            const reporter = this.feedback.getReporter(Cache.user);

            const replacements = {
                'reporter_name': reporter?.name || reporter?.email || '',
                'feedback_link': window.location.origin + '/viewer/' + Cache.account.id + '/' + this.feedback.get('project_id') + '/' + this.feedback.escape('share_key') + '/',
                'user_name'    : Cache.user.get(Cache.real_user_id).get('name') || Cache.user.get(Cache.real_user_id).get('email') || ''
            }
            // handle wildcard replacement
            content = this.replaceWildcard(content, replacements);

            // replace the content line break with <br>
            content = content.replace(/\n/g, '<br>');

            var _fallback = () => {
                var comment = this.$el.find('.new-comment').html();
                comment = comment.replace(/<br>$/, '');
                comment += content;
                this.$el.find('.new-comment').html(comment);
                this.placeCaretAtEnd();
            };

            _fallback();

            this.$el.find('.comment-template').hide();
        }
    },

    initialize: function(options) {
        this.views = {
            emoji: {},
            comment_template: {}
        };

        this.attachment_info    = {};
        this.video_capture_info = {};

        this.feedback     = options.feedback;
        this.is_public    = this.isPublic();
        this.inbox_view   = !!options.inbox_view;
        this.mention_list = [];
        this.notify_list  = [];
        this.is_viewer    = options.is_viewer;

        if (Cache.account.hasFeature('reply_templates')) {
            this.views.comment_template = new View_Comment_Template({editable: !this.is_viewer});
            this.listenTo(this.views.comment_template, 'comment::insert',  this.event_handlers.handleCommentInsert.bind(this));
        }

        // this.mention_list: options in the dropdown
        // this.notify_list: people who will be notified

        var reporter_info = this.feedback.getReporter(Cache.user);
        // add reporter to the mention list
        if (reporter_info && reporter_info.type === 'public') {
            this.mention_list.unshift({
                user_id     : 0,
                is_internal : false,
                is_reporter : true,
                name        : reporter_info.name,
                email       : reporter_info.email,
                silent      : this.isEmailUnsubscribed(reporter_info.email)
            });

            // notify reporter when it is not an internal comment
            if (this.is_public && !this.isEmailUnsubscribed(reporter_info.email)) {
                this.notify_list.push(reporter_info.email);
            }
        }

        // @all
        this.mention_list.unshift({
            user_id : -1,
            name    : '@all (notify everyone)',
            email   : ''
        });

        var reply_to = this.getReplyTo();

        var reporter_email = reporter_info ? reporter_info.email : '';

        // add public users (portal,guest) which replying to the mention list
        if (reply_to.email && reply_to.type === 'public'&& reply_to.email !== reporter_email && this.feedback.get('is_shared')) {
            this.mention_list.push({
                user_id     : 0,
                is_internal : false,
                name        : reply_to.name,
                email       : reply_to.email,
                silent      : this.isEmailUnsubscribed(reply_to.email)
            });

            // notify user when it is not an internal comment
            if (this.is_public && !this.isEmailUnsubscribed(reply_to.email)) {
                this.notify_list.push(reply_to.email);
            }
        }

        // add project users to the mention list
        Cache.app.getUsersByProject(this.feedback.get('project_id')).forEach((user) => {
            if (user.id === Cache.real_user_id) {
                return;
            }

            var user_role = this.getUserRole(user.id);

            var is_user_internal = user_role === Constants.ADMIN || user_role === Constants.ASSIGNEE;

            this.mention_list.push({
                user_id     : user.id,
                role        : user_role,
                is_internal : is_user_internal,
                name        : user.get('name'),
                email       : user.get('email'),
                silent      : false
            });

            if (this.getUserNotification(user.id).indexOf('my_feedback_comment') !== -1 && this.isMyFeedback(user)) {
                // my comment + Someone comments without @mentioning me
                this.notify_list.push(user.get('email'));
            } else if (this.getUserNotification(user.id).indexOf('reply') !== -1 && reply_to.type === 'internal' && reply_to.email === user.get('email')) {
                // reply to my comment + Someone responds to my comments
                this.notify_list.push(user.get('email'));
            }
        });

        // add user to the notify list when notification is not turned off
        this.notify_list = Util.arrayUnique(this.notify_list);

        // bind events
        $(document).on('click.' + this.cid, this.dom_handlers.documentClick.bind(this));

        this.on('remove', function() {
            $(document).off('click.' + this.cid);
        });

        this.uploader = new Dnd_File_Uploader(
            this.event_handlers.handleFiles.bind(this),
            this.event_handlers.handleDragEnter.bind(this),
            undefined,
            this.event_handlers.handleDragLeave.bind(this)
        );
    },

    getUserNotification: function(user_id) {
        var notifications = [];

        Cache.notification.where({user_id: user_id}).forEach((model) => {
            notifications.push(model.get('action'));
        });

        return notifications;
    },

    replaceWildcard: function(content, replacements) {
        return content.replace(/%%(.*?)%%/g, function(match, key) {
            return replacements[key] !== undefined ? replacements[key] : match;
        });
    },

    // users who have commented within the thread
    getThreadUserIds: function() {
        var thread_user_ids  = [];
        var project_user_ids = [];

        var result = [];

        Cache.app.getUsersByProject(this.feedback.get('project_id')).forEach(function(user) {
            project_user_ids.push(user.id);
        });

        if (this.model) {
            // author of the comment
            if (this.model.get('user_id')) {
                thread_user_ids.push(this.model.get('user_id'));
            }

            // people who have commented within the thread
            Cache.feedback_comment.where({reply_comment_id: this.model.id}).forEach(function(model) {
                if (model.get('user_id')) {
                    thread_user_ids.push(model.get('user_id'));
                }

                Cache.feedback_comment.where({reply_comment_id: model.id}).forEach(function(reply) {
                    if (reply.get('user_id')) {
                        thread_user_ids.push(reply.get('user_id'));
                    }
                });
            }.bind(this));
        } else {
            Cache.feedback_comment.where({feedback_id: this.feedback.id, reply_comment_id: 0, screen_x: 0, video_time: 0}).forEach(function(model) {
                if (model.get('user_id')) {
                    thread_user_ids.push(model.get('user_id'));
                }
            }.bind(this));
        }

        Util.arrayUnique(thread_user_ids).forEach(function(user_id) {
            if (project_user_ids.indexOf(user_id) !== -1) {
                result.push(user_id);
            }
        });

        return result;
    },

    // is the comment public or internal?
    isPublic: function() {
        if (!Cache.account.hasFeature('team_comments')) {
            return true;
        }

        if (Cache.getRealWorkspaceMember() && !Cache.getRealWorkspaceMember().hasAccess(Constants.ACCESS_PUBLIC_COMMENT, this.feedback.get('project_id'))) {
            return false;
        }

        if (this.model) {
            if (this.model.get('is_public')) {
                if (this.model.get('reply_comment_id')) {
                    var parent_comment = Cache.feedback_comment.get(this.model.get('reply_comment_id'));

                    if (parent_comment && !parent_comment.get('is_public')) {
                        return false;
                    }
                }
            } else {
                return false;
            }
        } else {
            // it's a description
            return true;
        }

        return true;
    },

    getUserRole: function(id) {
        if (id && Cache.workspace_member.findWhere({user_id: id})) {
            return Cache.workspace_member.findWhere({user_id: id}).get('role');
        }
        return '';
    },

    getReplyTo: function() {
        if (this.isTopThread()) {
            // reporter
            var reporter_info = this.feedback.getReporter(Cache.user);

            if (reporter_info) {
                return reporter_info;
            }
        } else {
            // thread author
            if (this.model.get('user_id')) {
                var user = Cache.user.get(this.model.get('user_id'));

                if (user) {
                    return {
                        type  : 'internal',
                        email : Cache.user.get(this.model.get('user_id')).get('email'),
                        name  : Cache.user.get(this.model.get('user_id')).get('name')
                    };
                } else {
                    // deleted user
                }
            } else {
                // portal user or guest
                return {
                    type  : 'public',
                    email : this.model.get('anon_email'),
                    name  : this.model.get('anon_name')
                }
            }
        }

        return {
            email : '',
            name  : ''
        };
    },

    disable: function() {
        this.$el.find('.reply-submit').addClass('loading').prop('disabled', true);
        this.$el.find('.attachment-launcher').addClass('disabled');
    },

    enable: function() {
        this.$el.find('.reply-submit').removeClass('loading').prop('disabled', false);
        this.$el.find('.attachment-launcher').removeClass('disabled');
    },

    toggle: function() {
        this.$el.toggleClass('open');
    },

    show: function() {
        this.$el.addClass('open');
    },

    hide: function() {
        this.$el.removeClass('open');
    },

    focus: function() {
        this.$el.find('.new-comment').focus();
    },

    clearMessage: function() {
        this.$el.find('.new-comment').html('');
        this.$el.find('.new-comment-attachment').html('');

        this.attachment_info = {};
        this.video_capture_info = {};
    },

    hasUnsavedChanges: function() {
        if (!_.isEmpty(this.attachment_info) || !_.isEmpty(this.video_capture_info) || this.getComment()) {
            return true;
        } else {
            return false;
        }
    },

    getComment: function() {
        var comment = this.$el.find('.new-comment').html();

        var temp_element = $('<div>').html(comment);
        temp_element.find('.at-name').each(function() {
            var user_id = $(this).attr('userid');
            this.outerHTML = '@@:' + user_id + ':' + $(this).text() + '@@';
        });

        comment = temp_element.html();
        comment = Util.sanitizeContenteditable(comment);
        comment = comment.replaceAll('\u200C', '');
        comment = comment.trim();

        return comment;
    },

    addAllToNotifyList: function() {
        this.notify_list = [];

        this.mention_list.forEach(function(list) {
            if (list.email && (this.is_public || list.is_internal) && !list.silent) {
                this.notify_list.push(list.email);
            }
        }.bind(this));
    },

    onEmojiSelect: function(emoji) {
        this.$el.find('.new-comment').focus();

        var _fallback = () => {
            var comment = this.$el.find('.new-comment').html();
            comment = comment.replace(/<br>$/, '');
            comment += emoji;
            this.$el.find('.new-comment').html(comment);
            this.placeCaretAtEnd();
        };

        if (this.comment_selection) {
            try {
                this.comment_selection.deleteContents();
                this.comment_selection.insertNode(document.createTextNode(emoji));
                this.comment_selection.collapse(false);

                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.comment_selection);
            } catch (e) {
                _fallback();
            }
        } else {
            _fallback();
        }

        this.views.emoji.hide();
    },

    renderCommentStatusCheckbox: function() {
        var id = _.uniqueId('internal-');
        var is_disabled = this.model && !this.model.get('is_public');
        var workspace_member = Cache.getRealWorkspaceMember();

        if (workspace_member && !workspace_member.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, this.feedback.get('project_id'))) {
            is_disabled = true;
        }

        this.$el.find('.comment-status-launcher').html(
            '<input type="checkbox" id="' + id + '"' + (this.is_public ? '' : ' checked') + (is_disabled ? ' disabled' : '') + '>' +
            '<label for="' + id + '"><i class="fas fa-lock"></i> Internal</label>'
        );
    },

    getMentionDropdownItem: function(info, allow_select) {
        var is_disabled = (!this.is_public && !info.is_internal) || info.silent;

        var do_notify;

        if (info.user_id === -1) {
            var total = 0;
            this.mention_list.forEach((list) => {
                if (list.email && (this.is_public || list.user_id) && !list.silent) {
                    total++;
                }
            });

            do_notify = total === this.notify_list.length && total > 1;
        } else {
            do_notify = info.email && this.notify_list.indexOf(info.email) !== -1;
        }

        var class_names = [];
        if (do_notify) {
            class_names.push('selected');
        }

        if (is_disabled) {
            class_names.push('disabled');
        }

        var display_name = info.name ? info.name : info.email;

        var mention_dropdown = '<li data-id="' + info.user_id + '"' + (class_names.length ? ' class="' + (class_names.join(' ')) + '"' : '') + '>';

        if (info.user_id === 0) {
            mention_dropdown += (info.is_reporter ? 'Reporter<br>' : 'Visitor<br>') +
                                '<span class="text-info">' + Util.htmlEntities(display_name) + '</span>';
            if (info.silent) {
                mention_dropdown += '<span class="text-info-light margin-left-4 tooltip" data-title="' + (info.is_reporter ? 'Reporter ' : 'Guest ') + 'has opted out of email updates"><i class="fa-solid fa-bell-slash"></i></span>';
            }
        } else {
            mention_dropdown += Util.htmlEntities(display_name);

            if (info.user_id > 0 && info.silent) {
                mention_dropdown += '<span class="text-info-light margin-left-4 tooltip" data-title="Notification is turned off"><i class="fa-solid fa-bell-slash"></i></span>';
            }
        }

        mention_dropdown += '</li>';

        return mention_dropdown
    },

    updateMentionDropdown: function() {
        if (!Cache.real_user_id) {
            return;
        }

        var mention_dropdown = '<li class="dropdown-title">Notify by Email</li>';

        this.mention_list.forEach((list) => {
            mention_dropdown += this.getMentionDropdownItem(list, true);
        });

        this.$el.find('.mention-list ul.dropdown').html(mention_dropdown);
        this.$el.find('.mention-count').text(this.notify_list.length);

        if (this.notify_list.length === 0) {
            this.$el.find('.mention-launcher').data('title', '');
        } else if (this.notify_list.length === 1) {
            this.$el.find('.mention-launcher').data('title', '1 person will be notified');
        } else {
            this.$el.find('.mention-launcher').data('title', this.notify_list.length + ' people will be notified');
        }


        this.$el.find('.mention-launcher i').toggleClass('mention-waring', !!this.notify_list.length);

        this.$el.find('.at-list li[data-internal="0"]').not('[data-silent="1"]').toggleClass('disabled', !this.is_public);
    },

    placeCaretAtEnd: function() {
        var el = this.$el.find('.new-comment').get(0);

        el.focus();

        if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange != 'undefined') {
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    },

    isTopThread: function() {
        if (!this.model) {
            // feedback description
            return true;
        }

        if (this.model.get('screen_number')) {
            return true;
        }

        if (this.model.get('video_time')) {
            return true;
        }

        return false;
    },

    // is user reporter or assignee
    isMyFeedback: function(user) {
        if (this.feedback.get('user_id') === user.id) {
            return true;
        } else if (this.feedback.get('uploader_user_id') === user.id) {
            return true;
        } else {
            return false;
        }
    },

    isEmailUnsubscribed: function(email) {
        var unsubscribed_emails = typeof Cache.get('feedback_unsubscribed_emails') === 'object' ?  Cache.get('feedback_unsubscribed_emails') : Cache.feedback_unsubscribed_emails || {};

        if (typeof unsubscribed_emails[this.feedback.id] !== 'undefined' && unsubscribed_emails[this.feedback.id].indexOf(email) !== -1) {
            return true;
        } else {
            return false;
        }
    },

    renderAttachment: function(file_name, file_type, file_content) {
        this.$el.find('.new-comment-attachment').removeClass('new-comment-attachment-video');

        if (Util.isImage(file_name)) {
            this.$el.find('.new-comment-attachment').html(
                '<img src="' + file_content + '">' +
                '<button class="attachment-remove" type="button">' +
                    '<i class="fas fa-times-circle"></i>' +
                '</button>'
            );
        } else if (Util.isVideo(file_name)) {
            this.$el.find('.new-comment-attachment').html(
                '<video src="' + file_content + '"></video>' +
                '<button class="attachment-remove" type="button">' +
                    '<i class="fas fa-times-circle"></i>' +
                '</button>' +
                '<button class="video-play" type="button">' +
                    '<i class="fas fa-play-circle"></i>' +
                '</button>'
            );

            this.$el.find('.new-comment-attachment').addClass('new-comment-attachment-video');
        } else {
            this.$el.find('.new-comment-attachment').html(
                '<span>' + Util.htmlEntities(file_name) + '</span>' +
                '<button class="attachment-remove" type="button">' +
                    '<i class="fas fa-times-circle"></i>' +
                '</button>'
            );
        }

        this.attachment_info = {
            file_name    : file_name,
            file_type    : file_type,
            file_content : file_content
        };

        this.$el.find('.attachment-launcher').addClass('disabled');
    },

    render: function() {
        var at_dropdown = '<div class="dropdown-box at-list"><ul class="dropdown dropdown-short">';
        this.mention_list.forEach((list) => {
            if (list.user_id) {
                at_dropdown += '<li data-id="' + Util.htmlEntities(list.user_id) + '" data-silent="' +  (list.silent ? 1 : 0) + '" data-internal="' + (list.is_internal ? '1' : '0') + '"' + (list.silent ? ' class="disabled"' : '') + '>' + Util.htmlEntities(list.name);

                if (list.silent) {
                    at_dropdown += '<span class="text-info-light margin-left-4 tooltip" data-title="Notification is turned off"><i class="fa-solid fa-bell-slash"></i></span>';
                }

                at_dropdown += '</li>';
            }
        });
        at_dropdown += '</ul></div>';

        var content = at_dropdown +
        '<div class="new-comment-container">' +
            '<div class="new-comment" contenteditable="true" data-placeholder="' + Util.htmlEntities(this.placeholder) + '"></div>' +
            // fix buggy auto focus on contenteditable when clicking outside
            // ref: https://stackoverflow.com/questions/34354085/clicking-outside-a-contenteditable-div-stills-give-focus-to-it
            '<div class="new-comment-resolver">&nbsp;</div>' +
            '<div class="new-comment-action-bar">' +
                '<div class="new-comment-attachment"></div>' +
                '<div class="new-comment-toolbar">' +
                    (Cache.real_user_id && !Cache.app.isClient() && Cache.account.hasFeature('team_comments') ?
                    '<div class="comment-status-launcher"></div>' : '') +
                    (Cache.real_user_id && !Cache.app.isClient() ?
                    '<div class="comment-template-button-dropdown button-dropdown button-dropdown-left" data-append="true" data-flip="true" data-offset="-120,4">' +
                        '<button type="button" class="template-launcher"><i class="fa-regular fa-file-lines"></i></button>' +
                        '<div class="comment-template dropdown-box"></div>' +
                    '</div>': '') +

                    '<div class="emoji-launcher"><span><i class="far fa-smile" style="pointer-events:none;"></i></span></div>' +

                    '<div class="region-emoji"></div>' +

                    '<div class="attachment-launcher"><i class="far fa-paperclip"></i></div>' +

                    (Cache.real_user_id && this.mention_list.length ?
                    '<div class="mention-launcher tooltip"><i class="far fa-solid fa-bell"></i><span class="mention-count"></span></div>' +
                    '<div class="mention-list dropdown-box"><ul class="dropdown dropdown-short dropdown-select"></ul></div>' : '') +

                    '<button class="reply-submit text-info square round small tooltip" data-title="Send"><i class="fas fa-paper-plane-top"></i></button>'+

                '</div>' +
            '</div>' +
            '<div class="dnd-dropzone" style="display: none"></div>' +
        '</div>';

        this.$el.toggleClass('internal', !this.is_public);
        this.$el.html(content);

        this.renderCommentStatusCheckbox();
        this.updateMentionDropdown();

        if (!this.is_public) {
            this.$el.addClass('internal');
        }

        this.uploader.setupDropArea(this.$el.get(0));

        if (Cache.real_user_id && !Cache.app.isClient() && Cache.account.hasFeature('reply_templates')) {
            this.views.comment_template.render().$el.appendTo(this.$el.find('.comment-template'));
        }

        return this;
    }
});